import { fetchApi } from 'utils/request';
import { taskEither } from 'fp-ts';
import { pipe } from 'fp-ts/lib/function';
import { deleteRunnersTE, getRunnerTE, listAllRunnersTE, listRunnersTE } from 'api/runners/apiEffectsTE';
import { errorToReactLeft } from 'utils/fp';
import { toQueryParams } from 'api/apiUtils';

export const runnersApiEffects = {
  // API Methods:
  getRunner: ({
    userId,
    clusterId,
    nodepoolId,
    runnerId,
  }: {
    userId: string;
    clusterId: string;
    nodepoolId: string;
    runnerId: string;
  }): Promise<CF.API.Compute.Runner> =>
    fetchApi<CF.API.Compute.Runner>({
      path: `/api/_api/v2/users/${userId}/compute_clusters/${clusterId}/nodepools/${nodepoolId}/runners/${runnerId}`,
      method: 'GET',
    }),
  listRunners: ({ userId, clusterId, nodepoolId }: { userId: string; clusterId: string; nodepoolId: string }): Promise<CF.API.Compute.Runner[]> =>
    fetchApi<CF.API.Compute.Runner[]>({
      path: `/api/_api/v2/users/${userId}/compute_clusters/${clusterId}/nodepools/${nodepoolId}/runners`,
      method: 'GET',
    }),
  listAllRunners: ({ userId, modelVersionIds }: { userId: string; modelVersionIds?: string[] }): Promise<CF.API.Compute.Runner[]> =>
    fetchApi<CF.API.Compute.Runner[]>({
      path: `/api/_api/v2/users/${userId}/runners${modelVersionIds ? `?${toQueryParams(modelVersionIds, 'model_version_ids')}` : ''}`,
      method: 'GET',
    }),
  deleteRunner: ({ userId, clusterId, nodepoolId, runnerId }: { userId: string; clusterId: string; nodepoolId: string; runnerId: string }) =>
    fetchApi<{ status: CF.API.Status }>({
      path: `/api/_api/v2/users/${userId}/compute_clusters/${clusterId}/nodepools/${nodepoolId}/runners/${runnerId}`,
      method: 'DELETE',
    }),

  // TE Methods:
  getRunnerTE: ({ userId, clusterId, nodepoolId, runnerId }: { userId: string; clusterId: string; nodepoolId: string; runnerId: string }) =>
    pipe(
      getRunnerTE({ userId, clusterId, nodepoolId, runnerId }, errorToReactLeft),
      taskEither.map((request) => request.runner),
    ),
  listRunnersTE: ({ userId, clusterId, nodepoolId }: { userId: string; clusterId: string; nodepoolId: string }) =>
    pipe(
      listRunnersTE({ userId, clusterId, nodepoolId }, errorToReactLeft),
      taskEither.map((request) => request.runners),
    ),
  listAllRunnersTE: ({ userId, modelVersionIds }: { userId: string; modelVersionIds?: string[] }) =>
    pipe(
      listAllRunnersTE({ userId, modelVersionIds }, errorToReactLeft),
      taskEither.map((request) =>
        request.runners
          // HACK: filter out any non local-dev runners (for now)...
          .filter((runner) => runner.nodepool.compute_cluster?.cluster_type === 'local-dev'),
      ),
    ),
  deleteRunnersTE: ({ userId, clusterId, nodepoolId, runnerIds }: { userId: string; clusterId: string; nodepoolId: string; runnerIds: string[] }) =>
    pipe(
      deleteRunnersTE({ userId, clusterId, nodepoolId, runnerIds }, errorToReactLeft),
      taskEither.map((request) => request),
    ),
};
